module.exports = __webpack_public_path__ + "img/purple3.0d6ff703.svg";